<template>
  <div class="content-wrapper view-report-download-hq p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <div class="header-topic">
            <h4><i class="fas fa-file-download"></i> การดาวน์โหลดรายงาน</h4>
          </div>

          <div class="report-buttons-warper">
            <div class="report-buttons">
              <b-button class="outline-btn" variant="outline-secondary" @click="openStockMovementReportModal">
                <i class="fas fa-file-download"></i> ดาวน์โหลดความเคลื่อนไหวสต๊อก
              </b-button>
              <b-button class="outline-btn" variant="outline-secondary" @click="openStockBalanceReportModal">
                <i class="fas fa-file-download"></i> ดาวน์โหลดยอดคงเหลือสต๊อก
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <StockMovementReportModalHQ ref="stockMovementReportModalHQ" @error="showDialogToast('danger', $event)">
      </StockMovementReportModalHQ>
      <StockBalanceReportModalHQ ref="stockBalanceReportModalHQ" @error="showDialogToast('danger', $event)">
      </StockBalanceReportModalHQ>
      <Dialog ref="Dialog"></Dialog>
    </div>
  </div>
</template>

<script>
import StockMovementReportModalHQ from "../../components/modal/ProductAndStock/StockMovementReportModalHQ.vue";
import StockBalanceReportModalHQ from "../../components/modal/ProductAndStock/StockBalanceReportModalHQ.vue";
import Dialog from "../../components/modal/Dialog.vue";

export default {
  name: "ReportDownloadHQ",
  components: {
    StockMovementReportModalHQ,
    StockBalanceReportModalHQ,
    Dialog,
  },
  methods: {
    openStockMovementReportModal() {
      this.$refs.stockMovementReportModalHQ.show();
    },
    openStockBalanceReportModal() {
      this.$refs.stockBalanceReportModalHQ.show();
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style scoped>
.header-topic {
  display: flex;
  gap: 8px;
  align-items: center;
}

.report-buttons-warper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  padding: 24px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.report-buttons {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  margin-top: 16px;
  padding: 24px;
  border: 0px solid #dee2e6;
  border-radius: 4px;
}

.report-buttons .btn {
  white-space: nowrap;
  padding: 12px 24px;
  text-align: left;
}
</style>
